import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import UploadingModal from './UploadingModal';
import { DialogBox } from '@components';
import Uploader from './Uploader';

const UploadDialog = ({
  open,
  showAdd,
  setOpen,
  typeText,
  multiple,
  acceptFiles,
  isUploading,
  handleUpload,
  selectedFiles,
  setSelectedFiles,
}) => {
  const { t } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {showAdd && (
        <Button variant="outlined" color="primary" onClick={handleClickOpen}>
          {t('add')}
        </Button>
      )}
      <UploadingModal isUploading={isUploading} />
      <DialogBox
        handleClose={handleClose}
        isOpened={open && !isUploading}
        actions={
          <>
            <Button variant="outlined" onClick={handleClose} color="primary">
              {t('cancel')}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={handleUpload}
              disabled={isEmpty(selectedFiles)}>
              {t('upload')}
            </Button>
          </>
        }
        title={t('upload_file')}>
        <Uploader
          typeText={typeText}
          multiple={multiple}
          acceptFiles={acceptFiles}
          selectedFiles={selectedFiles}
          handleSelectedFiles={setSelectedFiles}
        />
      </DialogBox>
    </div>
  );
};

UploadDialog.defaultProps = {
  showAdd: true,
  selectedFiles: [],
};

UploadDialog.propTypes = {
  open: PropTypes.bool,
  showAdd: PropTypes.bool,
  setOpen: PropTypes.func,
  multiple: PropTypes.bool,
  typeText: PropTypes.string,
  isUploading: PropTypes.bool,
  handleUpload: PropTypes.func,
  selectedFiles: PropTypes.array,
  setSelectedFiles: PropTypes.func,
  acceptFiles: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

export default UploadDialog;
